/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Inspector_HtmlInputs */

const en_image_inspector_html = /** @type {(inputs: Image_Inspector_HtmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HTML`)
};

const ar_image_inspector_html = /** @type {(inputs: Image_Inspector_HtmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HTML`)
};

const bn_image_inspector_html = /** @type {(inputs: Image_Inspector_HtmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HTML`)
};

const de_image_inspector_html = /** @type {(inputs: Image_Inspector_HtmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HTML`)
};

const es_image_inspector_html = /** @type {(inputs: Image_Inspector_HtmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HTML`)
};

const fr_image_inspector_html = /** @type {(inputs: Image_Inspector_HtmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HTML`)
};

const pt_image_inspector_html = /** @type {(inputs: Image_Inspector_HtmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HTML`)
};

const zh_image_inspector_html = /** @type {(inputs: Image_Inspector_HtmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HTML`)
};

const tr_image_inspector_html = /** @type {(inputs: Image_Inspector_HtmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HTML`)
};

const ru_image_inspector_html = /** @type {(inputs: Image_Inspector_HtmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HTML`)
};

const pl_image_inspector_html = /** @type {(inputs: Image_Inspector_HtmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HTML`)
};

/**
* | output |
* | --- |
* | "HTML" |
*
* @param {Image_Inspector_HtmlInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const image_inspector_html = /** @type {((inputs?: Image_Inspector_HtmlInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Inspector_HtmlInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_image_inspector_html(inputs)
	if (locale === "bn") return bn_image_inspector_html(inputs)
	if (locale === "de") return de_image_inspector_html(inputs)
	if (locale === "es") return es_image_inspector_html(inputs)
	if (locale === "fr") return fr_image_inspector_html(inputs)
	if (locale === "pt") return pt_image_inspector_html(inputs)
	if (locale === "zh") return zh_image_inspector_html(inputs)
	if (locale === "tr") return tr_image_inspector_html(inputs)
	if (locale === "ru") return ru_image_inspector_html(inputs)
	if (locale === "pl") return pl_image_inspector_html(inputs)
	return en_image_inspector_html(inputs)
});